/**
 * Formatter object containing utility functions for formatting numbers and dates.
 */
export const formatter: {
  integer(x: number | string | undefined): string;

  getTime(value: string | number | Date): string;

  getDateTime(value: string | number | Date): string;

  getEventDate(value: string | Date): string;

  getEventTimeRange(startDate: string | Date, endDate: string | Date): string;
} = {
  integer: (x: number | string | undefined): string => {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0";
  },

  getTime: (value: string | number | Date): string => {
    const dateTime: Date = new Date(new Date(value).toISOString());

    return value
      ? dateTime

          .toLocaleTimeString("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
          })
          .replace(":", "h")
      : "";
  },

  getDateTime: (value: string | number | Date): string => {
    const dateTime: Date = new Date(value);
    return value
      ? dateTime.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }) +
          " à " +
          dateTime.toLocaleTimeString("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
          })
      : "";
  },

  /**
   * Format date to French format: "Lundi 10 Mars"
   */
  getEventDate: (value: string | Date): string => {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  },

  /**
   * Format time range: "de 10h à 11H"
   */
  getEventTimeRange: (
    startDate: string | Date,
    endDate: string | Date,
  ): string => {
    if (!startDate || !endDate) return "";
    const start = new Date(startDate);
    const end = new Date(endDate);

    const startTime = start
      .toLocaleTimeString("fr-FR", {
        hour: "numeric",
        minute: "2-digit",
      })
      .replace(":", "h");

    const endTime = end
      .toLocaleTimeString("fr-FR", {
        hour: "numeric",
        minute: "2-digit",
      })
      .replace(":", "H");

    return `de ${startTime} à ${endTime}`;
  },
};
